import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PaymentService } from '../payment.service';
import { Payment } from '@core/models/payment';
import { UtilsService } from '@core/services';

const style = {
  base: {
    color: '#3f4146',
    fontFamily: '"Inter", sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#b0b7c3'
    }
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a'
  }
};
@Component({
  selector: 'app-payment',
  templateUrl: 'payment-register.component.html',
  styleUrls: ['./payment-register.component.scss']
})
export class PaymentRegisterComponent implements OnInit, AfterViewInit {
  payment = new Payment();
  stripe: any;
  elements: any;
  cardNumber: any;
  cardExpiry: any;
  cardCvc: any;

  cardValidation: any = {};

  processing: boolean = true;
  error: any;
  locale = 'en';

  constructor(
    public utilsService: UtilsService,
    private paymentService: PaymentService,
    private route: ActivatedRoute
  ) {}

  public ngOnInit(): void {
    const { data, queryParams } = this.route.snapshot;
    const { clientMail, invoiceNumber, amount, currency } = queryParams;
    this.payment.clientMail = clientMail;
    this.payment.description = `Payment invoice ${invoiceNumber}`;
    this.payment.invoiceNumber = invoiceNumber; // ???
    this.payment.amount = parseFloat(amount);
    this.payment.currency = currency ? currency : 'EUR';
    this.payment.metadata = {
      purchaseType: 'invoice',
      invoiceNumber
    };
    this.locale = this.payment.currency === 'EUR' ? 'es' : 'en';
    this.stripe = data.stripe;
    this.elements = this.stripe.elements({
      locale: 'auto'
    });
  }

  ngAfterViewInit(): void {
    this.setStripeElements();
  }

  setStripeElements(): void {
    this.resetCardValidation();

    this.cardNumber = this.createStripeElement('cardNumber', 'card-number');
    this.cardExpiry = this.createStripeElement('cardExpiry', 'card-expiry-date');
    this.cardCvc = this.createStripeElement('cardCvc', 'card-cvc');
  }

  resetCardValidation(): void {
    this.cardValidation = {
      cardNumber: false,
      cardExpiry: false,
      cardCvc: false
    };
  }

  createStripeElement(type: string, domElementId: string): any {
    const stripeElement = this.elements.create(type, { style });
    stripeElement.mount(`#${domElementId}`);

    stripeElement.on('focus', function () {
      // eslint-disable-next-line
      const el = document.getElementById(domElementId);
      el.classList.add('focused');
      (el.previousSibling as Element).classList.add('focused');
    });

    stripeElement.on('blur', function () {
      // eslint-disable-next-line
      var el = document.getElementById(domElementId);
      el.classList.remove('focused');
      (el.previousSibling as Element).classList.remove('focused');
    });

    stripeElement.on('change', (event) => {
      this.cardValidation[event.elementType] = event.complete;
    });

    return stripeElement;
  }

  handleSubmit(): void {
    this.resetCardValidation();
    this.paymentService.createPaymentIntent(this.payment).subscribe((response) => {
      this.stripe
        .confirmCardPayment(response.intentSecret, {
          /* eslint-disable @typescript-eslint/naming-convention */
          receipt_email: this.payment.clientMail,
          payment_method: {
            card: this.cardNumber,
            billing_details: {
              email: this.payment.clientMail
            }
          }
          /* eslint-enable */
        })
        .then((result) => {
          if (result.error) {
            this.error = result.error;
          } else {
            this.payment.status = result.paymentIntent.status;
            this.paymentService.pay(this.payment).subscribe({
              next: () => console.info('payment saved'),
              error: (err) => console.error('payment error', err)
            });
          }
          this.processing = false;
        });
    });
  }

  reset(): void {
    window.location.reload();
  }
}
